/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_TitleInputs */

const en_merge_event_group_title = /** @type {(inputs: Merge_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Event Group`)
};

const fr_merge_event_group_title = /** @type {(inputs: Merge_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner le groupe d'evenements`)
};

const de_merge_event_group_title = /** @type {(inputs: Merge_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführungsereignisgruppe`)
};

const it_merge_event_group_title = /** @type {(inputs: Merge_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci gruppo di eventi`)
};

const ru_merge_event_group_title = /** @type {(inputs: Merge_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа мероприятий по слиянию`)
};

const es_merge_event_group_title = /** @type {(inputs: Merge_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar grupo de eventos`)
};

const zh_cn2_merge_event_group_title = /** @type {(inputs: Merge_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并事件组`)
};

const ja_merge_event_group_title = /** @type {(inputs: Merge_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループを結合`)
};

const hi_merge_event_group_title = /** @type {(inputs: Merge_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह को मर्ज करें`)
};

const pt_pt2_merge_event_group_title = /** @type {(inputs: Merge_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos de Fusão`)
};

/**
* | output |
* | --- |
* | "Merge Event Group" |
*
* @param {Merge_Event_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_title = /** @type {((inputs?: Merge_Event_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_title(inputs)
	if (locale === "de") return de_merge_event_group_title(inputs)
	if (locale === "it") return it_merge_event_group_title(inputs)
	if (locale === "ru") return ru_merge_event_group_title(inputs)
	if (locale === "es") return es_merge_event_group_title(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_title(inputs)
	if (locale === "ja") return ja_merge_event_group_title(inputs)
	if (locale === "hi") return hi_merge_event_group_title(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_title(inputs)
	return en_merge_event_group_title(inputs)
});